import { go, mapL, rangeL, reduce } from "fxjs/es";
export const getConsolidatedTransformMatrix = (el) => {
  const transform_list = el.transform.baseVal;
  return go(
    rangeL(transform_list.numberOfItems),
    mapL((i) => transform_list.getItem(i)),
    mapL(({ matrix: m }) => m),
    reduce((m1, m2) => m1.multiply(m2))
  );
};
